function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointerI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 37.877,
    viewBox: "0 0 40 37.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6457"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41413",
    d: "m356.08-1309.458 4.443-.012a.768.768 0 0 1 .526-.132c.8 0 1.6-.017 2.4.009.428-.012.856-.011 1.284 0a.986.986 0 0 1 1.113 1.1c.006.183 0 .366 0 .549q.028 2.187 0 4.375a3.358 3.358 0 0 1-.056.98 1.021 1.021 0 0 1-1.053.671q-4.09.018-8.18 0a.669.669 0 0 1-.476-.142z",
    transform: "translate(-356.08 1327.939)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41415",
    d: "M356.08-1233.559c2.865 0 5.731-.006 8.6.006a1.012 1.012 0 0 0 1.018-.554.4.4 0 0 1 .03.554c0 .076-.013.153-.013.229-.012 1.124-.129 1.243-1.235 1.243h-8.4z",
    transform: "translate(-356.08 1259.433)",
    style: {
      fill: "#05315c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41416",
    d: "M436.828-1487.525c.042-1.549-.349-1.514-1.542-1.484-.231.006-.462-.007-.694-.011a.674.674 0 0 1-.144-.515q-.009-1.97 0-3.941a.843.843 0 0 1 .1-.486c.091-.1.177-.034.236.028a1.369 1.369 0 0 0 1.106.35q3.861-.007 7.721 0a4.137 4.137 0 0 0 .462-.013c.476-.053.714-.264.732-.733.034-.891.038-1.784 0-2.675a.682.682 0 0 0-.7-.714 4.373 4.373 0 0 0-.554-.016h-7.536a1.562 1.562 0 0 0-1.279.389.135.135 0 0 1-.17.013.8.8 0 0 1-.117-.529v-8.57c0-.552.124-.934.686-1.037h6.121a.877.877 0 0 1 .137.659q.006 2.652 0 5.305a4.149 4.149 0 0 0 .015.553.687.687 0 0 0 .95.634 17.21 17.21 0 0 0 1.273-.418 1.652 1.652 0 0 1 1.173 0q.586.214 1.184.392c.646.194 1.012-.068 1.049-.747.017-.307.005-.615.006-.922v-4.8a.877.877 0 0 1 .137-.659l8.836-.01a.754.754 0 0 1 .788.742 2.648 2.648 0 0 1 0 .277v20.918c0 .138-.01.277-.015.415a6.174 6.174 0 0 0-3.908 1.134 2.27 2.27 0 0 1-1.194.3c-.848-.017-1.7-.009-2.546 0a1.379 1.379 0 0 1-.9-.3c-.993-.782-1.978-1.575-2.964-2.366-.126-.1-.287-.2-.237-.41.19-.183.431-.139.656-.14 1.092-.006 2.185 0 3.277 0 .856 0 1.026-.173 1.022-1.029a1.737 1.737 0 0 0-.046-.638 1.342 1.342 0 0 0-1.425-1.014c-1.975-.011-3.949 0-5.924-.005a1.5 1.5 0 0 0-.941.327c-.65.5-1.325.956-1.975 1.451a1.924 1.924 0 0 1-1.419.44c-.465-.07-.973.109-1.437-.145z",
    transform: "translate(-427.184 1507.487)",
    style: {
      fill: "#e5b323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41417",
    d: "M468.408-1312.974c1.1.868 2.2 1.731 3.285 2.607a1.127 1.127 0 0 0 .761.264c.786-.01 1.573-.038 2.356.007a2.85 2.85 0 0 0 1.7-.465 8.073 8.073 0 0 1 2.385-.961 1.856 1.856 0 0 1 1.258.113l.108.1c0 .24-.212.284-.366.363-1.084.552-2.159 1.126-3.269 1.622-.928.415-1.966.531-2.909.9a8.429 8.429 0 0 1-5.019.271c-1.91-.413-3.857-.649-5.784-.99a13.808 13.808 0 0 0-2.119-.1c-.212 0-.437.037-.614-.132v-4.428c.447 0 .9-.036 1.34 0a2.112 2.112 0 0 0 1.574-.5c.626-.5 1.283-.954 1.926-1.429a1.3 1.3 0 0 1 .8-.3c2.049.007 4.1 0 6.148.006a1.4 1.4 0 0 1 1.452 1.1c-.07.476-.448.5-.8.509-1.016.023-2.033.008-3.049.009-1.053 0-1.055 0-1.117 1.02a1.454 1.454 0 0 0-.047.414z",
    transform: "translate(-450.534 1333.762)",
    style: {
      fill: "#ffe2cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41418",
    d: "M407.551-1507.511a.94.94 0 0 0-.547.882q.012 4.638.012 9.277a.563.563 0 0 1 .132.424q.016 1.231 0 2.462a.563.563 0 0 1-.132.424q0 2.494-.01 4.987h-2.965v-17.409c0-.858.2-1.063 1.056-1.061.82.001 1.637.008 2.454.014z",
    transform: "translate(-399.6 1507.525)",
    style: {
      fill: "#ad871a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41419",
    d: "M513.938-1507.376v6.322c0 .878-.476 1.268-1.263.912a3.879 3.879 0 0 0-3.4 0c-.787.356-1.262-.034-1.263-.912v-6.322z",
    transform: "translate(-493.935 1507.388)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41420",
    d: "M459.9-1263.132a28.021 28.021 0 0 1 6.332.716c1.524.25 3.044.521 4.571.755a3.339 3.339 0 0 0 1.339-.3c1.288-.345 2.568-.722 3.849-1.093a2.609 2.609 0 0 0 .461-.209c1.173-.608 2.385-1.139 3.529-1.8a.866.866 0 0 1 .545.789c.008.385-.265.6-.585.757-1.213.6-2.4 1.268-3.645 1.792a28.329 28.329 0 0 1-2.944.9 5.522 5.522 0 0 0-.8.219 5.669 5.669 0 0 1-3.6.118c-2.274-.413-4.554-.8-6.841-1.14a15.271 15.271 0 0 0-2.215-.015l-.029-.554q.021-.468.033-.935z",
    transform: "translate(-450.259 1287.523)",
    style: {
      fill: "#ffc89e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41412",
    d: "M597.473-1171.273a1.489 1.489 0 0 1 1.576-1.208c1.913 0 3.827.026 5.739-.016a1.9 1.9 0 0 1 1.469.614c.372.369.762.723 1.107 1.115a1.444 1.444 0 0 0 1.215.515c1.481-.029 2.962-.01 4.443-.01v4.436a.926.926 0 0 1-.664.132c-1.5 0-2.992.038-4.486-.007a27.015 27.015 0 0 0-5.882.5c-1.817.344-3.649.613-5.473.921a2.313 2.313 0 0 1-1.049-.059c-1.437-.413-2.876-.818-4.313-1.231a3.266 3.266 0 0 1-.562-.21c-1.062-.53-2.126-1.055-3.184-1.592-.169-.086-.389-.136-.406-.388a1.941 1.941 0 0 1 1.857-.1 3.332 3.332 0 0 1 .46.191c.185-.127.357-.028.523.04a4.342 4.342 0 0 1 .865.43 3.168 3.168 0 0 0 2.053.517 33.155 33.155 0 0 1 2.581 0 3.19 3.19 0 0 0 2.184-.519.666.666 0 0 0 .209-.092c.965-.5 1.812-1.177 2.724-1.755a1.776 1.776 0 0 0 .615-.461 2.109 2.109 0 0 1-.041-.642c0-.7-.007-.7-.685-.706s-1.326 0-1.989 0a1 1 0 0 1-.886-.415z",
    transform: "translate(-573.022 1200.75)",
    style: {
      fill: "#eab4ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41414",
    d: "M581.67-1121.4a23.909 23.909 0 0 0 5.986 2.586 12.7 12.7 0 0 1 2.035.577 4.232 4.232 0 0 0 2.434.026c1.946-.329 3.9-.614 5.839-.984 2.508-.479 5.035-.179 7.552-.264.724-.025 1.449 0 2.174 0v1.479c-2.021 0-4.044.049-6.062-.015a25.439 25.439 0 0 0-4.988.5c-1.921.318-3.838.659-5.759.973a2.845 2.845 0 0 1-1.208-.258q-2.02-.562-4.037-1.136a1.772 1.772 0 0 1-.3-.131q-1.842-.917-3.683-1.836a.775.775 0 0 1-.529-.743.819.819 0 0 1 .546-.774z",
    transform: "translate(-567.689 1154.389)",
    style: {
      fill: "#d39e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41421",
    d: "M620.353-1129.893a2.491 2.491 0 0 1-1.893.656c-1.184-.053-2.373-.032-3.559-.005a2.254 2.254 0 0 1-1.257-.365 6.031 6.031 0 0 0-1.625-.753 1.373 1.373 0 0 1 1.508-1 4.139 4.139 0 0 1 1.534.442.359.359 0 0 1 .352-.009 1.245 1.245 0 0 1 .292.137 4.793 4.793 0 0 0 3.333.76 4.879 4.879 0 0 1 1.315.137z",
    transform: "translate(-595.72 1163.435)",
    style: {
      fill: "#d39e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41422",
    d: "M699.963-1159.279a3.467 3.467 0 0 0 1.954.27c.245.009.492-.017.735.006.326.032.83-.175.941.105a1.88 1.88 0 0 1-.029 1.374c-.918 0-1.836 0-2.754-.007-.58 0-.844-.264-.853-.832-.005-.305.003-.611.006-.916z",
    transform: "translate(-675.512 1188.757)",
    style: {
      fill: "#ffc89e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41423",
    d: "M650.152-1130.875c-.923 0-1.846-.014-2.769 0a1.783 1.783 0 0 1-1-.285 7.223 7.223 0 0 0-1.528-.74 1.517 1.517 0 0 1 1.664-.5 8.9 8.9 0 0 1 2.753 1.158 1.569 1.569 0 0 0 .956.272z",
    transform: "translate(-625.519 1164.418)",
    style: {
      fill: "#b98881"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41424",
    d: "M436.148-1399.956v-3.31a.965.965 0 0 1 1.007-.568c2.774.011 5.548 0 8.322.006.77 0 1.031.259 1.033 1.018 0 .831.005 1.661 0 2.492 0 .64-.29.924-.939.924-2.82 0-5.641 0-8.461.006a.941.941 0 0 1-.962-.568z",
    transform: "translate(-428.731 1413.438)",
    style: {
      fill: "#e5b323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41425",
    d: "M547.9-1302.152a3.241 3.241 0 0 1-.078-1.391c0-.249.249-.172.4-.173 1.3-.006 2.606-.008 3.909 0a.821.821 0 0 0 .781-.382 2.611 2.611 0 0 1 .045 1.311c-.061.4-.387.551-.794.548a341.283 341.283 0 0 0-3.786 0c-.164.001-.346-.068-.477.087z",
    transform: "translate(-530.022 1322.941)",
    style: {
      fill: "#ffc89e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerI);
export default __webpack_public_path__ + "static/media/pointerI.ecd6f5f5778216d40c2aa5c6d9aa04b6.svg";
export { ForwardRef as ReactComponent };